<template>
  <nav class="belt__pagination--nav">
    <a href="" class="belt__pagination--prev" v-on:click.prevent="setPreviousPage()" v-bind:disabled="isFirstPage() || loading.state" v-bind:title="$lang.pagination.prev_page">
      <i class="onp-chevron-left" aria-hidden="true"></i>
    </a>
    <div class="belt__pagination--input-container">
      <p>
        <input class="belt__pagination--input" type="number" min="1" v-bind:max="totalPagesNum" placeholder="Page number" v-bind:value="getCurrentPage" v-on:change="updateCurrentPage($event)" v-bind:disabled="loading.state">
      </p>
      <p class="belt__pagination--max" v-if="appIsRunning">
        <span class="belt__pagination--max-from">{{ $lang.pagination.from_pages }}</span> <a href="" v-on:click.prevent="setActivePage(totalPagesNum)" v-bind:title="totalPagesNum">{{ totalPagesNum }}</a>
      </p>
    </div>
    <a href="" class="belt__pagination--next" v-on:click.prevent="setNextPage()" v-bind:disabled="isLastPage() || loading.state" v-bind:title="$lang.pagination.next_page">
      <i class="onp-chevron-right" aria-hidden="true"></i>
    </a>
  </nav>
</template>

<script>
import * as pagination from './../../scripts/modules/pagination'
import { mapGetters} from 'vuex'

export default {
  name: 'paginationWithInput',
  methods: {
    isFirstPage: function() {
      return pagination.isFirstPage()
    },
    isLastPage: function() {
      return pagination.isLastPage()
    },
    setPreviousPage: function() {
      return pagination.setPreviousPage()
    },
    setNextPage: function() {
      return pagination.setNextPage()
    },
    setActivePage: function(n) {
      return pagination.setActivePage(n)
    },
    updateCurrentPage: function(event) {
      return pagination.updateCurrentPage(event)
    }
  },
  computed: {
    ...mapGetters({
      loading: 'GET_LOADING_STATE',
      totalPagesNum: 'GET_TOTAL_PAGES_NUM',
      currentPage: 'GET_CURRENT_PAGE',
      appIsRunning: 'GET_APP_IS_RUNNING'
    }),
    getCurrentPage () {
      return (this.appIsRunning) ? this.currentPage : ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// PaginationWithInput.vue?5e13ea51